/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

$(function() {
  	var touchingCarousel = false,
      touchStartCoords;

    document.body.addEventListener('touchstart', function(e) {
      if (e.target.closest('.flickity-slider')) {
        touchingCarousel = true;
      } else {
        touchingCarousel = false;
        return;
      }

      touchStartCoords = {
        x: e.touches[0].pageX,
        y: e.touches[0].pageY
      }
    });

    document.body.addEventListener('touchmove', function(e) {
      if (!(touchingCarousel && e.cancelable)) {
        return;
      }

      var moveVector = {
        x: e.touches[0].pageX - touchStartCoords.x,
        y: e.touches[0].pageY - touchStartCoords.y
      };

      if (Math.abs(moveVector.x) > 7)
        e.preventDefault()

    }, {passive: false});  
  
    $('.Carousel_slick').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      fade: true,
      asNavFor: '.Carousel_slick_nav'
    });
  
    $('.Carousel_slick_nav').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.Carousel_slick',
      dots: false,
      arrows: true,
      useTransform: false,
      centerMode: true,
      centerPadding: '30px',
      focusOnSelect: true,
      prevArrow: '<button class="slide-arrow prev-arrow"></button>',
   	  nextArrow: '<button class="slide-arrow next-arrow"></button>',
      responsive: [
        {
          breakpoint: 1280,
          settings: {
            arrows: true,
            dots: false,
            centerMode: true,
            centerPadding: '25px',
            focusOnSelect: true,
            slidesToShow: 4,
      		slidesToScroll: 1
          }
        },  
        {
          breakpoint: 1024,
          settings: {
            arrows: true,
            dots: false,
            centerMode: true,
            centerPadding: '20px',
            focusOnSelect: true,
            slidesToShow: 3,
      		slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            dots: false,
            centerMode: true,
            centerPadding: '15px',
            focusOnSelect: true,
            slidesToShow: 3,
      		slidesToScroll: 1
          }
        },
        {
          breakpoint: 767,
          settings: {
            arrows: false,
            dots: true,
            centerMode: true,
            centerPadding: '15px',
            focusOnSelect: true,
            slidesToShow: 1,
      		slidesToScroll: 1
          }
        }
      ]
    });
  
  	getVariant();
});

var script_loaded=!1;function loadJSscripts(){if(!script_loaded){script_loaded=!0;var t=document.getElementsByTagName("script");for(i=0;i<t.length;i++)if(null!==t[i].getAttribute("data-src")){var e=document.createElement("script");e.src=t[i].getAttribute("data-src"),document.body.appendChild(e)}document.dispatchEvent(new CustomEvent("StartAsyncLoading")),setTimeout(function(){document.dispatchEvent(new CustomEvent("StartPreviewBarLoading"))},700)}}window.addEventListener("scroll",function(t){setTimeout(function(){loadJSscripts()},500)}),window.addEventListener("mousemove",function(){setTimeout(function(){loadJSscripts()},500)}),window.addEventListener("touchstart",function(){setTimeout(function(){loadJSscripts()},500)}),window.addEventListener?window.addEventListener("load",function(){setTimeout(loadJSscripts,5e3)},!1):window.attachEvent?window.attachEvent("onload",function(){setTimeout(loadJSscripts,5e3)}):window.onload=loadJSscripts;

function getVariant(){
  var url =  window.location.href;
  if(url.includes("variant")){
  	var id = url.split("=");
    console.log(id);
    id = id[1];
    if(id !== undefined && id != ""){
    	var listSlide = $("section.Product").find(".Carousel_slick .Product__SlideItem");  
        var el_id = $("section.Product").find("form [name=id]");
      	var data_img = $(el_id).find("option[value='"+id+"']").data("featured_media");

        for(var i=0; i< listSlide.length; i++){
             var slide_media = $(listSlide[i]).data("featured_media");

             if(data_img !== undefined && data_img.includes(slide_media)){
                  $('.Carousel_slick').slick('slickGoTo', i);
                  break;
             }
      	}            
    }
  }
}


// CD Sanket
$(document).on('click','#js_loader',function(e){
  e.preventDefault();

  $('span[loader]').removeClass('hide');
  $('span[load_more_text]').addClass('hide');

  var $this =  $(this).parent();
  var data_next_url= $this.attr('data_next_url');
  var data_total_pages= $this.attr('data_total_pages');
  var data_current_page=parseInt($this.attr('data_current_page'));
  var pg_current_page_plus=data_current_page + 1;
  var pag_update_page= $this.attr('data_current_page',pg_current_page_plus);
  var new_url=data_next_url.replace(/page=[0-9]+/,'page='+pg_current_page_plus);
  var pagination_pages_int=parseInt(data_total_pages);

  $.ajax({
    url: new_url,
    type:'GET',
    datatype:'html',
    success: function(data){
      var get_ul=$(data).find('.ProductList').html();
      $('.ProductList').append(get_ul);

      if(pg_current_page_plus >= pagination_pages_int){
        $('#Load_more_products').css("display", "none");
      }
      $('span[loader]').addClass('hide');
      $('span[load_more_text]').removeClass('hide');
    }
  })
});

/* OBF LINK */
document.addEventListener("DOMContentLoaded", function(event) {
	var classname = document.getElementsByClassName("obflink");
	for (var i = 0; i < classname.length; i++) {
		//click gauche
		classname[i].addEventListener('click', myFunction, false);
		//click droit
		classname[i].addEventListener('contextmenu', myRightFunction, false);
	}
});

var myFunction = function(event) {
	var attribute = this.getAttribute("data-href");               
			if(event.ctrlKey) {                   
				 var newWindow = window.open(attribute, '_blank');                    
				 newWindow.focus();               
			} else {                    
				 document.location.href= attribute;
			}
	};
//fonction du click droit
var myRightFunction = function(event) {
	var attribute = this.getAttribute("data-href");               
		if(event.ctrlKey) {                   
			 var newWindow = window.open(attribute, '_blank');                    
			 newWindow.focus();               
		} else {      
			 window.open(attribute,'_blank');	
		}
} 
/* OBF LINK */

//CD
document.addEventListener("DOMContentLoaded",function(){
  if(window.innerWidth < 1140) {
    var desktopMenu = document.querySelector(".Header__MainNav");
    var noScriptDesktop = document.createElement("noscript");
    noScriptDesktop.innerHTML = desktopMenu.outerHTML;
    desktopMenu.parentNode.replaceChild(noScriptDesktop,desktopMenu);
  } else {
    var mobileMenuDrawer = document.querySelector("#shopify-section-sidebar-menu");
    var noScriptMobileMenu = document.createElement("noscript");
    noScriptMobileMenu.innerHTML = mobileMenuDrawer.outerHTML;
    mobileMenuDrawer.parentNode.replaceChild(noScriptMobileMenu,mobileMenuDrawer);

    var mobileMenuButton = document.querySelector(".btn-mobile-menu");
    var noScriptMobileBtn = document.createElement("noscript");
    noScriptMobileBtn.innerHTML = mobileMenuButton.outerHTML;
    mobileMenuButton.parentNode.replaceChild(noScriptMobileBtn,mobileMenuButton);
  }
});